export const marketingConsentPartnersSE = ['All'];
